import { has } from 'lodash'
import { BaseOutput, isBaseOutput } from './base-output.model'

export interface ConfirmPinSmsOutput extends BaseOutput {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  UrlRedirect?: string
}

export const isConfirmPinSmsOutput = (output: unknown): output is ConfirmPinSmsOutput =>
  isBaseOutput(output) && has(output, 'UrlRedirect')
